import { db } from "../firebaseConfig";
import {
  collection, addDoc, updateDoc, deleteDoc, doc,
  serverTimestamp, query, where, orderBy, getDocs, getDoc
} from "firebase/firestore";

// Types supportés: "featured" | "row" | "banner"
const COLLECTION = "homeSections";

const clean = (d = {}) => {
  const type = d.type || "row";
  return {
    title: (d.title || "").trim(),
    type,
    order: Number.isFinite(d.order) ? d.order : 100,
    active: !!d.active,
    // pour les sections "row"/"featured"
    query: {
      brandId: d.query?.brandId || "",
      categoryId: d.query?.categoryId || "",
      limit: Math.min(Math.max(Number(d.query?.limit || 10), 1), 30),
      // tri optionnel: "new" | "price_asc" | "price_desc"
      sort: d.query?.sort || "new",
    },
    // pour les "banner"
    banner: type === "banner" ? {
      image: d.banner?.image || "",
      href: d.banner?.href || "/catalogue",
      alt: d.banner?.alt || d.title || "Promotion",
    } : null,
    createdAt: d.createdAt || serverTimestamp(),
    updatedAt: serverTimestamp(),
  };
};

export async function addHomeSection(data) {
  const payload = clean(data);
  const ref = await addDoc(collection(db, COLLECTION), payload);
  return ref.id;
}

export async function updateHomeSection(id, patch) {
  const snap = await getDoc(doc(db, COLLECTION, id));
  if (!snap.exists()) throw new Error("Section introuvable");
  const merged = { ...snap.data(), ...patch };
  const payload = clean(merged);
  await updateDoc(doc(db, COLLECTION, id), payload);
}

export async function deleteHomeSection(id) {
  await deleteDoc(doc(db, COLLECTION, id));
}

export async function listHomeSections() {
  const q = query(collection(db, COLLECTION), orderBy("order", "asc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

// Public : sections actives
export async function listActiveHomeSections() {
  const q = query(
    collection(db, COLLECTION),
    where("active", "==", true),
    orderBy("order", "asc")
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}